import styled from 'styled-components';
import NotificationIconSVG from '../../assets/images/notification-inactive-icon.svg';

const NotificationIcon = styled.span`
  background: url(\"${NotificationIconSVG}\") no-repeat center center;
  background-size: 21px 25px;
  display: block;
  height: 35px;
  width: 35px;
  position: relative;
  cursor: default;
  position: relative;
`;

export default NotificationIcon;
